import { IPassengerDto, IPassengerDtoComputedKeys } from "@ryde/shared";

export interface IUseBulkPassengersMessageProps {
  selectedPassengersIds: number[];
  hasRecipientsDerivedFromRides?: boolean;
}

export enum BulkPassengersMessageFormFieldsEnum {
  subject = "subject",
  message = "message",
  preview = "preview",
  isEmail = "isEmail",
  isSms = "isSms",
  isPush = "isPush",
  lastRideWithinDays = "lastRideWithinDays",
}

/**
 * Bounds of the rides participation filter. Mirrors LAST_RIDE_WITHIN_DAYS_LIMITS on the backend —
 * keep the two in sync or the form will accept a value the API rejects with a 422.
 */
export const LAST_RIDE_WITHIN_DAYS_LIMITS = {
  min: 1,
  max: 730,
} as const;

/** Names the filter card for assistive tech via `aria-labelledby`. */
export const RIDES_PARTICIPATION_FILTER_TITLE_ID =
  "rides-participation-filter-title";

/** Ties the filter's description paragraph to the days input via `aria-describedby`. */
export const RIDES_PARTICIPATION_FILTER_DESCRIPTION_ID =
  "rides-participation-filter-description";

/** Keystrokes in the days field are coalesced before previewing the recipient list. */
export const RIDES_PARTICIPATION_PREVIEW_DEBOUNCE_MS = 400;

export const passengersMessageKeysMappedTemplates: Partial<
  Record<keyof IPassengerDto | keyof IPassengerDtoComputedKeys, string>
> = {
  firstName: "passenger.gridLabel.firstName",
  lastName: "passenger.gridLabel.lastName",
  sourceStation1Name: "passenger.gridLabel.sourceStation1Id",
  sourceStation2Name: "passenger.gridLabel.sourceStation2Id",
  sourceStation3Name: "passenger.gridLabel.sourceStation3Id",
  destinationStation1Name: "passenger.gridLabel.destinationStation1Id",
  destinationStation2Name: "passenger.gridLabel.destinationStation2Id",
  destinationStation3Name: "passenger.gridLabel.destinationStation3Id",
};
